import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
// Assuming a generic Modal component exists at this path
import Modal from '../../../components/ui/Modal'; 

const EditReviewModal = ({ isOpen, onClose, onSubmit, initialData, loading }) => {
    const [rating, setRating] = useState(initialData?.rating || 0);
    const [reviewText, setReviewText] = useState(initialData?.review || '');

    useEffect(() => {
        if (initialData) {
            setRating(initialData.rating || 0);
            setReviewText(initialData.review || '');
        }
    }, [initialData]);

    const handleSubmit = async () => {
        await onSubmit(initialData.id, initialData.reviewType, { rating, comment: reviewText });
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen} // Correct prop for generic Modal
            onClose={onClose} // Correct prop for generic Modal
            title={`Edit Review for ${initialData?.reviewedItemName}`}
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Rating</label>
                    <div className="flex items-center space-x-1">
                        {[...Array(5)].map((_, i) => (
                            <Icon
                                key={i}
                                name="Star"
                                size={24}
                                className={
                                    i < rating
                                        ? 'text-warning fill-current cursor-pointer'
                                        : 'text-gray-300 cursor-pointer'
                                }
                                onClick={() => setRating(i + 1)}
                            />
                        ))}
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Comment</label>
                    <textarea
                        className="w-full px-3 py-2 border rounded-lg resize-y"
                        rows={4}
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                        placeholder="Share your thoughts about this item..."
                    />
                </div>
            </div>
            {/* Footer buttons */}
            <div className="flex justify-end space-x-2 mt-6">
                <Button variant="outline" onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} disabled={loading} isLoading={loading}>
                    Save Changes
                </Button>
            </div>
        </Modal>
    );
};

export default EditReviewModal;
